import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, reorderArray } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { Storage } from "@ionic/storage";
import { AddmenusceltaPage } from '../addmenuscelta/addmenuscelta';
import { EditmenusceltaPage } from '../editmenuscelta/editmenuscelta';
import { SceltePage } from '../scelte/scelte';

import { EditmenuPage } from '../editmenu/editmenu';
import { SERVER_URL } from "../../config";

/**
 * Generated class for the MenusceltePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-menuscelte',
  templateUrl: 'menuscelte.html',
})
export class MenusceltePage {
  menuScelte: string[];
  errorMessage: string;
  menu;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public rest: RestApiProvider,
    private readonly storage: Storage,

  ) {
    this.menu = navParams.get('menu');
   

  }
  getScelte() {
    console.log('menu :' + this.menu);

    this.rest.getMenuScelte(this.menu)
      .subscribe(
        menuScelte => this.menuScelte = menuScelte,
        error => this.errorMessage = <any>error);

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MenusceltePage');
    console.log('Artilicoli LISTTTTTTTTTTTTTTTTTTTTTTT :' );
    this.getScelte();

    console.log('scelte:' + this.menuScelte);

  }
  reorderItems(indexes) {
    console.log("reorderItems:" + JSON.stringify(indexes));

    this.menuScelte = reorderArray(this.menuScelte, indexes);


    console.log("reorderItems list:" + JSON.stringify(this.menuScelte));
    var i = 0;
    this.menuScelte.forEach(function (element) {

      console.log(element["nome"]);
      element["visibilita"] = i;
      i++;
    });
    console.log("reorderItems list durante:" + JSON.stringify(this.menuScelte));



    this.rest.aggiornaListMenuScelte(this.menuScelte);

  }
  openAddMenuSceltaPage() {

    this.navCtrl.push(AddmenusceltaPage, { menu: this.menu });

  }
  openEditmenusceltaPage(menuscelta) {

    this.navCtrl.push(EditmenusceltaPage, { menuscelta: menuscelta });


  }
  openEditmenuPage() {
    this.navCtrl.push(EditmenuPage, { menu: this.menu });

  }
  openSceltePage(menuscelta){
    this.navCtrl.push(SceltePage, { menuscelta: menuscelta });

  }

}



// WEBPACK FOOTER //
// ./src/pages/menuscelte/menuscelte.ts